
// src/reducers/report-reducer.js

import { 
  POST_USER_REPORT,
  POST_USER_REPORT_REQUESTED,
  POST_USER_REPORT_COMPLETED,
  POST_USER_REPORT_FAILED,
  POST_CONTENT_REPORT,
  POST_CONTENT_REPORT_REQUESTED,
  POST_CONTENT_REPORT_COMPLETED,
  POST_CONTENT_REPORT_FAILED,
} from '../actions/report'

const initialState = {
  isRequesting: false,
}

export default function reportReducer(state = initialState, action = {}) {
  switch(action.type) {

  case POST_USER_REPORT_REQUESTED:
  case POST_CONTENT_REPORT_REQUESTED:
    return Object.assign({}, state, {
      isPosting: true,
      isPostFailed: false,
    })

  case POST_USER_REPORT_FAILED:
  case POST_CONTENT_REPORT_FAILED:
    return Object.assign({}, state, {
      isPosting: false,
      isPostFailed: true,
    })

  case POST_USER_REPORT_COMPLETED:
  case POST_CONTENT_REPORT_COMPLETED:
    return Object.assign({}, state, {
      isPosting: false,
      isPostFailed: true,
     })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report-reducer.js